import React from 'react'

import { EmojiIcon } from 'components/EmojiIcon'

import { Wrapper } from '../styles'

const Emoji = ({ emoji, isTeacher }) => {
    return (
        <Wrapper isTeacher={isTeacher}>
            <EmojiIcon emoji={emoji} size={100} />
        </Wrapper>
    )
}

export { Emoji }
